module.exports = __webpack_public_path__ + "img/users_white.0191075e.svg";